var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArduinoUnoIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "134px",
    height: "95px",
    viewBox: "0 0 134 95",
    style: {
      enableBackground: "new 0 0 134 95"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0F7391;}\r\n\t.st1{fill:#333333;}\r\n\t.st2{fill:none;stroke:#9A916C;stroke-width:0.372;}\r\n\t.st3{fill:#9A916C;}\r\n\t.st4{fill:none;stroke:#9A916C;stroke-width:0.3899;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:0.3961;stroke-linecap:round;}\r\n\t.st6{fill:#FFFFFF;}\r\n\t.st7{fill:#404040;}\r\n\t.st8{fill:#2A2A29;}\r\n\t.st9{fill:#474747;}\r\n\t.st10{fill:#595959;}\r\n\t.st11{fill:#373737;}\r\n\t.st12{fill:#8D8C8C;}\r\n\t.st13{fill:#8D8455;}\r\n\t.st14{fill:#8C8663;}\r\n\t.st15{fill:#B8AF82;}\r\n\t.st16{fill:#80795B;}\r\n\t.st17{fill:#5E5B43;}\r\n\t.st18{fill:#CCCCCC;}\r\n\t.st19{opacity:0.1;enable-background:new    ;}\r\n\t.st20{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st21{fill:#1A1A1A;}\r\n\t.st22{fill:#E6E6E6;}\r\n\t.st23{opacity:0.1;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st24{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st25{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st26{opacity:0.2;enable-background:new    ;}\r\n\t.st27{fill:#999999;}\r\n\t.st28{fill:#303030;}\r\n\t.st29{fill:#1F1F1F;}\r\n\t.st30{fill:#3D3D3D;}\r\n\t.st31{fill:#232323;}\r\n\t.st32{fill:#494949;}\r\n\t.st33{fill:#3D3D3D;fill-opacity:0.3;}\r\n\t.st34{fill:#0F0F0F;fill-opacity:0.4;}\r\n\t.st35{opacity:0.5;fill:none;stroke:#000000;stroke-width:0.1146;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st36{opacity:0.25;enable-background:new    ;}\r\n\t.st37{opacity:0.25;stroke:#565656;stroke-width:0.1146;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st38{fill:#6D6D6D;}\r\n\t.st39{fill:#808080;}\r\n\t.st40{fill:#B3B3B3;}\r\n\t.st41{opacity:0.5;fill:#CCCCCC;enable-background:new    ;}\r\n\t.st42{fill:#641D1C;}\r\n\t.st43{fill:#852725;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1725_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.0_3_",
    className: "st0",
    d: "M126.4,0l2.7,2.7v20.4l4.5,4.5V86l-4.5,4.5v2.7c0,1-0.8,1.8-1.8,1.8h0H13.3 c-1,0-1.8-0.8-1.8-1.8c0,0,0,0,0,0V1.8c0-1,0.8-1.8,1.8-1.8l0,0H126.4 M126.3,31.7c0,1.6,1.3,2.9,2.8,2.9c1.6,0,2.9-1.3,2.9-2.8 c0,0,0,0,0,0c0-1.6-1.3-2.9-2.8-2.9C127.6,28.8,126.3,30.1,126.3,31.7C126.3,31.7,126.3,31.7,126.3,31.7z M126.3,81.4 c0,1.6,1.3,2.9,2.8,2.9c1.6,0,2.9-1.3,2.9-2.8c0,0,0,0,0,0c0-1.6-1.3-2.9-2.8-2.9C127.6,78.6,126.3,79.8,126.3,81.4 C126.3,81.4,126.3,81.4,126.3,81.4z M35.8,4.5c0,1.6,1.3,2.9,2.8,2.9c1.6,0,2.9-1.3,2.9-2.8c0,0,0,0,0,0c0-1.6-1.3-2.9-2.8-2.9 C37.1,1.7,35.8,2.9,35.8,4.5C35.8,4.5,35.8,4.5,35.8,4.5L35.8,4.5z M33.5,90.5c0,1.6,1.3,2.9,2.8,2.9c1.6,0,2.9-1.3,2.9-2.8 c0,0,0,0,0,0c0-1.6-1.3-2.9-2.8-2.9S33.5,88.9,33.5,90.5C33.5,90.5,33.5,90.5,33.5,90.5z M101.2,90.5c0,0.4,0.3,0.8,0.8,0.8 c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C101.6,89.7,101.2,90.1,101.2,90.5C101.2,90.5,101.2,90.5,101.2,90.5z  M105.8,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C106.1,89.7,105.8,90.1,105.8,90.5 C105.8,90.5,105.8,90.5,105.8,90.5z M110.3,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C110.6,89.7,110.3,90.1,110.3,90.5C110.3,90.5,110.3,90.5,110.3,90.5z M114.8,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8 c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C115.1,89.7,114.8,90.1,114.8,90.5C114.8,90.5,114.8,90.5,114.8,90.5z M119.3,90.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C119.7,89.7,119.3,90.1,119.3,90.5 C119.3,90.5,119.3,90.5,119.3,90.5z M123.9,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C124.2,89.7,123.9,90.1,123.9,90.5C123.9,90.5,123.9,90.5,123.9,90.5z M124,40.7c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8 c0,0,0,0,0,0c0-0.5-0.4-0.8-0.8-0.8C124.4,39.9,124,40.2,124,40.7C124,40.7,124,40.7,124,40.7z M128.5,40.7c0,0.5,0.4,0.8,0.8,0.8 c0.5,0,0.8-0.4,0.8-0.8c0,0,0,0,0,0c0-0.5-0.4-0.8-0.8-0.8C128.9,39.9,128.5,40.2,128.5,40.7C128.5,40.7,128.5,40.7,128.5,40.7z  M124,45.2c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0,0,0,0,0,0c0-0.5-0.4-0.8-0.8-0.8C124.4,44.4,124,44.8,124,45.2 C124,45.2,124,45.2,124,45.2z M128.5,45.2c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0,0,0,0,0,0c0-0.5-0.4-0.8-0.8-0.8 C128.9,44.4,128.5,44.8,128.5,45.2C128.5,45.2,128.5,45.2,128.5,45.2z M124,49.8c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8 c0,0,0,0,0,0c0-0.5-0.4-0.8-0.8-0.8C124.4,48.9,124,49.3,124,49.8C124,49.8,124,49.8,124,49.8z M128.5,49.8c0,0.5,0.4,0.8,0.8,0.8 c0.5,0,0.8-0.4,0.8-0.8c0,0,0,0,0,0c0-0.5-0.4-0.8-0.8-0.8C128.9,48.9,128.5,49.3,128.5,49.8C128.5,49.8,128.5,49.8,128.5,49.8z  M47.8,10.4c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0,0,0,0,0,0c0-0.5-0.4-0.8-0.8-0.8C48.1,9.6,47.8,9.9,47.8,10.4 C47.8,10.4,47.8,10.4,47.8,10.4z M47.8,14.9c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0,0,0,0,0,0c0-0.5-0.4-0.8-0.8-0.8 C48.1,14.1,47.8,14.5,47.8,14.9C47.8,14.9,47.8,14.9,47.8,14.9z M43.2,10.4c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8 c0,0,0,0,0,0c0-0.5-0.4-0.8-0.8-0.8C43.6,9.6,43.2,9.9,43.2,10.4C43.2,10.4,43.2,10.4,43.2,10.4z M43.2,14.9c0,0.5,0.4,0.8,0.8,0.8 c0.5,0,0.8-0.4,0.8-0.8c0,0,0,0,0,0c0-0.5-0.4-0.8-0.8-0.8C43.6,14.1,43.2,14.5,43.2,14.9C43.2,14.9,43.2,14.9,43.2,14.9z  M38.7,10.4c0,0.5,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8C39.1,9.6,38.7,9.9,38.7,10.4z M38.7,14.9 c0,0.5,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8S38.7,14.5,38.7,14.9z M84.9,4.5c0,0.4,0.3,0.8,0.8,0.8 c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C85.3,3.8,84.9,4.1,84.9,4.5C84.9,4.5,84.9,4.5,84.9,4.5z M80.4,4.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C80.8,3.8,80.4,4.1,80.4,4.5 C80.4,4.5,80.4,4.5,80.4,4.5L80.4,4.5z M75.9,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C76.2,3.8,75.9,4.1,75.9,4.5C75.9,4.5,75.9,4.5,75.9,4.5z M71.4,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0 c0-0.4-0.3-0.8-0.8-0.8C71.7,3.8,71.4,4.1,71.4,4.5C71.4,4.5,71.4,4.5,71.4,4.5z M66.9,4.5c0,0.4,0.3,0.8,0.8,0.8 c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C67.2,3.8,66.9,4.1,66.9,4.5C66.9,4.5,66.9,4.5,66.9,4.5z M62.3,4.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C62.7,3.8,62.3,4.1,62.3,4.5 C62.3,4.5,62.3,4.5,62.3,4.5z M57.8,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C58.1,3.8,57.8,4.1,57.8,4.5C57.8,4.5,57.8,4.5,57.8,4.5z M53.3,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0 c0-0.4-0.3-0.8-0.8-0.8C53.6,3.8,53.3,4.1,53.3,4.5C53.3,4.5,53.3,4.5,53.3,4.5z M48.8,4.5c0,0.4,0.3,0.8,0.8,0.8 c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C49.1,3.8,48.8,4.1,48.8,4.5C48.8,4.5,48.8,4.5,48.8,4.5z M44.2,4.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C44.6,3.8,44.2,4.1,44.2,4.5 C44.2,4.5,44.2,4.5,44.2,4.5z M123.9,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C124.2,3.8,123.9,4.1,123.9,4.5C123.9,4.5,123.9,4.5,123.9,4.5z M119.3,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8 c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C119.7,3.8,119.3,4.1,119.3,4.5C119.3,4.5,119.3,4.5,119.3,4.5z M114.8,4.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C115.1,3.8,114.8,4.1,114.8,4.5 C114.8,4.5,114.8,4.5,114.8,4.5z M110.3,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C110.6,3.8,110.3,4.1,110.3,4.5C110.3,4.5,110.3,4.5,110.3,4.5z M105.8,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8 c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C106.1,3.8,105.8,4.1,105.8,4.5C105.8,4.5,105.8,4.5,105.8,4.5z M101.2,4.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C101.6,3.8,101.2,4.1,101.2,4.5 C101.2,4.5,101.2,4.5,101.2,4.5z M96.7,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C97,3.8,96.7,4.1,96.7,4.5C96.7,4.5,96.7,4.5,96.7,4.5z M92.2,4.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0 c0-0.4-0.3-0.8-0.8-0.8C92.5,3.8,92.2,4.1,92.2,4.5C92.2,4.5,92.2,4.5,92.2,4.5z M65,90.5c0,0.4,0.3,0.8,0.8,0.8 c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C65.4,89.7,65,90.1,65,90.5C65,90.5,65,90.5,65,90.5z M60.5,90.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C60.9,89.7,60.5,90.1,60.5,90.5 C60.5,90.5,60.5,90.5,60.5,90.5z M69.6,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C69.9,89.7,69.6,90.1,69.6,90.5C69.6,90.5,69.6,90.5,69.6,90.5z M74.1,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8 c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C74.4,89.7,74.1,90.1,74.1,90.5C74.1,90.5,74.1,90.5,74.1,90.5z M78.6,90.5 c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C79,89.7,78.6,90.1,78.6,90.5 C78.6,90.5,78.6,90.5,78.6,90.5z M83.1,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8 C83.5,89.7,83.1,90.1,83.1,90.5C83.1,90.5,83.1,90.5,83.1,90.5z M87.7,90.5c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8 c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C88,89.7,87.7,90.1,87.7,90.5C87.7,90.5,87.7,90.5,87.7,90.5z M92.2,90.5c0,0.4,0.3,0.8,0.8,0.8 c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0c0-0.4-0.3-0.8-0.8-0.8C92.5,89.7,92.2,90.1,92.2,90.5C92.2,90.5,92.2,90.5,92.2,90.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.0.6_3_",
    x: 42.6,
    y: 28.8,
    className: "st1",
    width: 8.9,
    height: 8.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.0.8_3_",
    x: 61,
    y: 60.8,
    className: "st1",
    width: 66,
    height: 10
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector0pin_4_",
    className: "st2",
    cx: 102,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.10_3_",
    className: "st3",
    d: "M101,88.2h2v4.7h-2V88.2 M101,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1l0,0c0-0.6-0.5-1-1-1 C101.4,89.5,101,89.9,101,90.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector1pin_4_",
    className: "st2",
    cx: 106.5,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.12_3_",
    className: "st3",
    d: "M105.5,88.2h2v4.7h-2V88.2 M105.5,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1l0,0 c0-0.6-0.5-1-1-1C106,89.5,105.5,89.9,105.5,90.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector2pin_4_",
    className: "st2",
    cx: 111,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.14_3_",
    className: "st3",
    d: "M110,88.2h2v4.7h-2V88.2 M110,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1l0,0c0-0.6-0.5-1-1-1 C110.5,89.5,110,89.9,110,90.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector3pin_4_",
    className: "st2",
    cx: 115.6,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.16_3_",
    className: "st3",
    d: "M114.5,88.2h2v4.7h-2V88.2 M114.5,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1l0,0 c0-0.6-0.5-1-1-1C115,89.5,114.5,89.9,114.5,90.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector4pin_4_",
    className: "st2",
    cx: 120.1,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.18_3_",
    className: "st3",
    d: "M119.1,88.2h2v4.7h-2V88.2 M119.1,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1l0,0 c0-0.6-0.5-1-1-1C119.5,89.5,119.1,89.9,119.1,90.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector5pin_4_",
    className: "st2",
    cx: 124.6,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.20_3_",
    className: "st3",
    d: "M123.6,88.2h2v4.7h-2V88.2 M123.6,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1l0,0 c0-0.6-0.5-1-1-1C124.1,89.5,123.6,89.9,123.6,90.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector39pin_3_",
    className: "st4",
    cx: 124.8,
    cy: 40.7,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector40pin_3_",
    className: "st4",
    cx: 129.4,
    cy: 40.7,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector41pin_3_",
    className: "st4",
    cx: 124.8,
    cy: 45.2,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector42pin_3_",
    className: "st4",
    cx: 129.4,
    cy: 45.2,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector43pin_3_",
    className: "st4",
    cx: 124.8,
    cy: 49.8,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector44pin_3_",
    className: "st4",
    cx: 129.4,
    cy: 49.8,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector45pin_3_",
    className: "st4",
    cx: 48.6,
    cy: 10.4,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector46pin_4_",
    className: "st4",
    cx: 48.6,
    cy: 14.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector47pin_4_",
    className: "st4",
    cx: 44.1,
    cy: 10.4,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector48pin_4_",
    className: "st4",
    cx: 44.1,
    cy: 14.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector49pin_4_",
    className: "st4",
    cx: 39.6,
    cy: 10.4,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector50pin_4_",
    className: "st4",
    cx: 39.6,
    cy: 14.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector51pin_4_",
    className: "st2",
    cx: 85.7,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.34_3_",
    className: "st3",
    d: "M84.7,2.2h2v4.7h-2V2.2 M84.7,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C85.1,3.5,84.7,4,84.7,4.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector52pin_4_",
    className: "st2",
    cx: 81.2,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.36_3_",
    className: "st3",
    d: "M80.2,2.2h2v4.7h-2V2.2 M80.2,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C80.6,3.5,80.2,4,80.2,4.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector53pin_4_",
    className: "st2",
    cx: 76.7,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.38_3_",
    className: "st3",
    d: "M75.6,2.2h2v4.7h-2V2.2 M75.6,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C76.1,3.5,75.6,4,75.6,4.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector54pin_3_",
    className: "st2",
    cx: 72.1,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.40_3_",
    className: "st3",
    d: "M71.1,2.2h2v4.7h-2V2.2 M71.1,4.5c0,0.6,0.5,1,1,1s1-0.5,1-1c0-0.6-0.5-1-1-1 C71.6,3.5,71.1,4,71.1,4.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector55pin_3_",
    className: "st2",
    cx: 67.6,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.42_3_",
    className: "st3",
    d: "M66.6,2.2h2v4.7h-2V2.2 M66.6,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C67,3.5,66.6,4,66.6,4.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector56pin_3_",
    className: "st2",
    cx: 63.1,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.44_3_",
    className: "st3",
    d: "M62.1,2.2h2v4.7h-2V2.2 M62.1,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C62.5,3.5,62.1,4,62.1,4.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector57pin_3_",
    className: "st2",
    cx: 58.6,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.46_3_",
    className: "st3",
    d: "M57.5,2.2h2v4.7h-2V2.2 M57.5,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 S57.5,4,57.5,4.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector58pin_3_",
    className: "st2",
    cx: 54,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.48_3_",
    className: "st3",
    d: "M53,2.2h2v4.7h-2V2.2 M53,4.5c0,0.6,0.5,1,1,1s1-0.5,1-1c0-0.6-0.5-1-1-1 C53.5,3.5,53,4,53,4.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector59pin_3_",
    className: "st2",
    cx: 49.5,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.50_3_",
    className: "st3",
    d: "M48.5,2.2h2v4.7h-2V2.2 M48.5,4.5c0,0.6,0.5,1,1,1s1-0.5,1-1c0-0.6-0.5-1-1-1 C49,3.5,48.5,4,48.5,4.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector60pin_3_",
    className: "st2",
    cx: 45,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.52_3_",
    className: "st3",
    d: "M44,2.2h2v4.7h-2V2.2 M44,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C44.4,3.5,44,4,44,4.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector61pin_3_",
    className: "st2",
    cx: 124.6,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.54_3_",
    className: "st3",
    d: "M123.6,2.2h2v4.7h-2V2.2 M123.6,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C124.1,3.5,123.6,4,123.6,4.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector62pin_3_",
    className: "st2",
    cx: 120.1,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.56_3_",
    className: "st3",
    d: "M119.1,2.2h2v4.7h-2V2.2 M119.1,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C119.5,3.5,119.1,4,119.1,4.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector63pin_3_",
    className: "st2",
    cx: 115.6,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.58_3_",
    className: "st3",
    d: "M114.5,2.2h2v4.7h-2V2.2 M114.5,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C115,3.5,114.5,4,114.5,4.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector64pin_3_",
    className: "st2",
    cx: 111,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.60_3_",
    className: "st3",
    d: "M110,2.2h2v4.7h-2V2.2 M110,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C110.5,3.5,110,4,110,4.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector65pin_3_",
    className: "st2",
    cx: 106.5,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.62_3_",
    className: "st3",
    d: "M105.5,2.2h2v4.7h-2V2.2 M105.5,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C106,3.5,105.5,4,105.5,4.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector66pin_3_",
    className: "st2",
    cx: 102,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.64_3_",
    className: "st3",
    d: "M101,2.2h2v4.7h-2V2.2 M101,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C101.4,3.5,101,4,101,4.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector67pin_3_",
    className: "st2",
    cx: 97.5,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.66_3_",
    className: "st3",
    d: "M96.5,2.2h2v4.7h-2V2.2 M96.5,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C96.9,3.5,96.5,4,96.5,4.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector68pin_3_",
    className: "st2",
    cx: 92.9,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.68_3_",
    className: "st3",
    d: "M91.9,2.2h2v4.7h-2V2.2 M91.9,4.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1 C92.4,3.5,91.9,4,91.9,4.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector84pin_3_",
    className: "st2",
    cx: 65.8,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector91pin_3_",
    className: "st2",
    cx: 61.3,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.71_3_",
    className: "st3",
    d: "M64.8,88.2h2v4.7h-2V88.2 M64.8,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1l0,0 c0-0.6-0.5-1-1-1C65.2,89.5,64.8,89.9,64.8,90.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.72_3_",
    className: "st3",
    d: "M60.3,88.2h2v4.7h-2V88.2 M60.3,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1l0,0 c0-0.6-0.5-1-1-1S60.3,89.9,60.3,90.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector85pin_3_",
    className: "st2",
    cx: 70.3,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.74_3_",
    className: "st3",
    d: "M69.3,88.2h2v4.7h-2V88.2 M69.3,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1l0,0 c0-0.6-0.5-1-1-1C69.8,89.5,69.3,89.9,69.3,90.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector86pin_3_",
    className: "st2",
    cx: 74.8,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.76_3_",
    className: "st3",
    d: "M73.8,88.2h2v4.7h-2V88.2 M73.8,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1l0,0 c0-0.6-0.5-1-1-1C74.3,89.5,73.8,89.9,73.8,90.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector87pin_3_",
    className: "st2",
    cx: 79.4,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.78_3_",
    className: "st3",
    d: "M78.4,88.2h2v4.7h-2V88.2 M78.4,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1l0,0 c0-0.6-0.5-1-1-1C78.8,89.5,78.4,89.9,78.4,90.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector88pin_3_",
    className: "st2",
    cx: 83.9,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.80_3_",
    className: "st3",
    d: "M82.9,88.2h2v4.7h-2V88.2 M82.9,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1l0,0 c0-0.6-0.5-1-1-1C83.3,89.5,82.9,89.9,82.9,90.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector89pin_3_",
    className: "st2",
    cx: 88.4,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.82_3_",
    className: "st3",
    d: "M87.4,88.2h2v4.7h-2V88.2 M87.4,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1l0,0 c0-0.6-0.5-1-1-1C87.9,89.5,87.4,89.9,87.4,90.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "connector90pin_3_",
    className: "st2",
    cx: 92.9,
    cy: 90.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.84_3_",
    className: "st3",
    d: "M91.9,88.2h2v4.7h-2V88.2 M91.9,90.5c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1l0,0 c0-0.6-0.5-1-1-1C92.4,89.5,91.9,89.9,91.9,90.5z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "_x30_.1.0.85_5_",
    className: "st5",
    x1: 58.5,
    y1: 18.3,
    x2: 125.7,
    y2: 18.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.0.96.0.0_4_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.96.0.0.0_4_",
    className: "st6",
    d: "M88.9,34.8c1.2-1.3,2.1-2.5,3.2-3.5c4.2-3.7,8.9-5.1,14.2-2.9 c5.1,2.1,7.8,7.4,6.7,12.8c-1,5-5.8,8.8-11.1,9c-4.9,0.2-8.5-2-11.5-5.5c-0.5-0.5-0.9-1.1-1.5-1.8c-0.4,0.5-0.7,0.9-1.1,1.3 c-3.3,4.1-7.3,6.4-12.7,6.1c-5.3-0.3-10.2-5.2-10.5-10.5c-0.4-6.7,4.7-12.3,11.9-12.3c4.7,0,8.4,2.4,11.3,6.1 C88.1,33.9,88.5,34.3,88.9,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.96.0.0.1_4_",
    className: "st0",
    d: "M77.2,31.2c-4.9,0-8.5,3.1-8.9,7.2c-0.4,3.6,2.5,7.2,6.5,8.1 c3.9,0.8,7-0.8,9.3-3.6c3.6-4.3,3.5-3.6,0-7.9C82.3,32.6,79.7,31.3,77.2,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.96.0.0.2_4_",
    className: "st0",
    d: "M101.6,31.1c-0.6,0-1,0-1.5,0.1c-4.2,0.8-6.8,3.6-8.7,7.1c-0.2,0.3-0.2,0.8,0,1.1 c1.8,3.1,4,5.7,7.5,6.8c3.4,1.1,6.4,0.2,8.8-2.4c2.1-2.4,2.6-5.1,1.2-8C107.4,32.7,104.7,31.3,101.6,31.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.0.96.0.1_4_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.96.0.1.0_4_",
    className: "st6",
    d: "M80.7,39.8c0,0.1-0.1,0.2-0.2,0.2h-7.3c-0.1,0-0.2-0.1-0.2-0.2v-2.2 c0-0.1,0.1-0.2,0.2-0.2h7.3c0.1,0,0.2,0.1,0.2,0.2V39.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.0.96.0.2_4_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.0.96.0.2.0_4_",
    className: "st6",
    d: "M104.7,37.6c0-0.1-0.1-0.2-0.2-0.2h-2.1c-0.1,0-0.2-0.1-0.2-0.2V35 c0-0.1-0.1-0.2-0.2-0.2h-2.2c-0.1,0-0.2,0.1-0.2,0.2v2.1c0,0.1-0.1,0.2-0.2,0.2h-2.1c-0.1,0-0.2,0.1-0.2,0.2v2.2 c0,0.1,0.1,0.2,0.2,0.2h2.1c0.1,0,0.2,0.1,0.2,0.2v2.1c0,0.1,0.1,0.2,0.2,0.2h2.2c0.1,0,0.2-0.1,0.2-0.2v-2.1 c0-0.1,0.1-0.2,0.2-0.2h2.1c0.1,0,0.2-0.1,0.2-0.2V37.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2851_",
    transform: "matrix(1, 0, 0, 1, 157.652, 140.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2852_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2853_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2854_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.1_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_x06_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.1.0.0_3_",
    x: -57.9,
    y: -52.4,
    className: "st7",
    width: 27.1,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.1.0.1_3_",
    x: -56.5,
    y: -51,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.2_3_",
    className: "st8",
    points: "-57.2,-51.7 -56.5,-51 -54.8,-51 -54.1,-51.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.3_3_",
    className: "st9",
    points: "-54.1,-51.7 -54.8,-51 -54.8,-49.3 -54.1,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.4_3_",
    className: "st10",
    points: "-54.1,-48.6 -54.8,-49.3 -56.5,-49.3 -57.2,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.5_3_",
    className: "st11",
    points: "-57.2,-48.6 -56.5,-49.3 -56.5,-51 -57.2,-51.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.1.0.6_3_",
    x: -52,
    y: -51,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.7_3_",
    className: "st8",
    points: "-52.7,-51.7 -52,-51 -50.3,-51 -49.6,-51.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.8_3_",
    className: "st9",
    points: "-49.6,-51.7 -50.3,-51 -50.3,-49.3 -49.6,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.9_3_",
    className: "st10",
    points: "-49.6,-48.6 -50.3,-49.3 -52,-49.3 -52.7,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.10_3_",
    className: "st11",
    points: "-52.7,-48.6 -52,-49.3 -52,-51 -52.7,-51.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.1.0.11_3_",
    x: -47.5,
    y: -51,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.12_3_",
    className: "st8",
    points: "-48.1,-51.7 -47.5,-51 -45.7,-51 -45.1,-51.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.13_3_",
    className: "st9",
    points: "-45.1,-51.7 -45.7,-51 -45.7,-49.3 -45.1,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.14_3_",
    className: "st10",
    points: "-45.1,-48.6 -45.7,-49.3 -47.5,-49.3 -48.1,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.15_3_",
    className: "st11",
    points: "-48.1,-48.6 -47.5,-49.3 -47.5,-51 -48.1,-51.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.1.0.16_3_",
    x: -43,
    y: -51,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.17_3_",
    className: "st8",
    points: "-43.6,-51.7 -43,-51 -41.2,-51 -40.6,-51.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.18_3_",
    className: "st9",
    points: "-40.6,-51.7 -41.2,-51 -41.2,-49.3 -40.6,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.19_3_",
    className: "st10",
    points: "-40.6,-48.6 -41.2,-49.3 -43,-49.3 -43.6,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.20_3_",
    className: "st11",
    points: "-43.6,-48.6 -43,-49.3 -43,-51 -43.6,-51.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.1.0.21_3_",
    x: -38.4,
    y: -51,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.22_3_",
    className: "st8",
    points: "-39.1,-51.7 -38.4,-51 -36.7,-51 -36,-51.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.23_3_",
    className: "st9",
    points: "-36,-51.7 -36.7,-51 -36.7,-49.3 -36,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.24_3_",
    className: "st10",
    points: "-36,-48.6 -36.7,-49.3 -38.4,-49.3 -39.1,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.25_3_",
    className: "st11",
    points: "-39.1,-48.6 -38.4,-49.3 -38.4,-51 -39.1,-51.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.1.0.26_3_",
    x: -33.9,
    y: -51,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.27_3_",
    className: "st8",
    points: "-34.6,-51.7 -33.9,-51 -32.2,-51 -31.5,-51.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.28_3_",
    className: "st9",
    points: "-31.5,-51.7 -32.2,-51 -32.2,-49.3 -31.5,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.29_3_",
    className: "st10",
    points: "-31.5,-48.6 -32.2,-49.3 -33.9,-49.3 -34.6,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.1.0.30_3_",
    className: "st11",
    points: "-34.6,-48.6 -33.9,-49.3 -33.9,-51 -34.6,-51.7  "
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2680_",
    transform: "matrix(1, 0, 0, 1, 191.155, 64.2515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2683_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2686_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2687_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.2_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32_x03_8_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2690_",
    transform: "matrix(0, -1, 1, 0, 3.52001, 17.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2691_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2698_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2699_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.2.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.2.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.2.0.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.0_3_",
    className: "st7",
    points: "43.5,-64.1 43.5,-66.5 43.5,-68.6 43.5,-71.1 42.6,-72  40.1,-72 39.2,-71.1 39.2,-68.6 39.2,-66.5 39.2,-64.1 40.1,-63.1 42.6,-63.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.1_3_",
    className: "st7",
    points: "39,-64.1 39,-66.5 39,-68.6 39,-71.1 38.1,-72 35.6,-72  34.6,-71.1 34.6,-68.6 34.6,-66.5 34.6,-64.1 35.6,-63.1 38.1,-63.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.2_3_",
    className: "st7",
    points: "34.5,-64.1 34.5,-66.5 34.5,-68.6 34.5,-71.1 33.6,-72  31.1,-72 30.1,-71.1 30.1,-68.6 30.1,-66.5 30.1,-64.1 31.1,-63.1 33.6,-63.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.3_3_",
    className: "st7",
    points: "43.5,-64.1 43.5,-66.5 43.5,-68.6 43.5,-71.1 42.6,-72  40.1,-72 39.2,-71.1 39.2,-68.6 39.2,-66.5 39.2,-64.1 40.1,-63.1 42.6,-63.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.4_3_",
    className: "st7",
    points: "39,-64.1 39,-66.5 39,-68.6 39,-71.1 38.1,-72 35.6,-72  34.6,-71.1 34.6,-68.6 34.6,-66.5 34.6,-64.1 35.6,-63.1 38.1,-63.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.5_3_",
    className: "st7",
    points: "34.5,-64.1 34.5,-66.5 34.5,-68.6 34.5,-71.1 33.6,-72  31.1,-72 30.1,-71.1 30.1,-68.6 30.1,-66.5 30.1,-64.1 31.1,-63.1 33.6,-63.1  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2847_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, -0.656, 6.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2848_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2849_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2850_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.2.0.0.0.0.6_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.2.0.0.0.0.6.0_3_",
    x: 75.8,
    y: 32.3,
    className: "st12",
    width: 1.4,
    height: 1.4
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2843_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, -7.8547, 13.9447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2844_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2845_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2846_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.2.0.0.0.0.7_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.2.0.0.0.0.7.0_3_",
    x: 78.5,
    y: 39.5,
    className: "st12",
    width: 1.4,
    height: 1.4
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2839_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 6.5428, 13.9447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2840_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2841_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2842_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.2.0.0.0.0.8_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.2.0.0.0.0.8.0_3_",
    x: 83,
    y: 29.7,
    className: "st12",
    width: 1.4,
    height: 1.4
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2835_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, -0.6552, 21.1442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2836_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2837_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2838_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.2.0.0.0.0.9_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.2.0.0.0.0.9.0_3_",
    x: 85.7,
    y: 36.9,
    className: "st12",
    width: 1.4,
    height: 1.4
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2827_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 13.7415, 21.1424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2828_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2833_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2834_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.2.0.0.0.0.10_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.2.0.0.0.0.10.0_3_",
    x: 90.2,
    y: 27,
    className: "st12",
    width: 1.4,
    height: 1.4
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2823_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 6.5423, 28.3417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2824_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2825_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2826_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.2.0.0.0.0.11_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.2.0.0.0.0.11.0_3_",
    x: 92.9,
    y: 34.2,
    className: "st13",
    width: 1.4,
    height: 1.4
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2819_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 6.5401, 28.3434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2820_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2821_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2822_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.2.0.0.0.0.12_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.2.0.0.0.0.12.0_3_",
    x: 93.3,
    y: 34.5,
    className: "st14",
    width: 0.7,
    height: 0.7
  })))))), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.13_3_",
    className: "st15",
    points: "42.2,-66 41.8,-65.7 41.8,-64.9 42.2,-64.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.14_3_",
    className: "st16",
    points: "41.1,-64.9 41.8,-64.9 42.2,-64.6 40.7,-64.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.15_3_",
    className: "st17",
    points: "41.1,-65.7 41.1,-64.9 40.7,-64.6 40.7,-66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.16_3_",
    className: "st3",
    points: "42.2,-66 41.8,-65.7 41.1,-65.7 40.7,-66  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2815_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 13.7423, 21.1432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2816_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2817_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2818_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.2.0.0.0.0.17_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.2.0.0.0.0.17.0_3_",
    x: 90.6,
    y: 27.3,
    className: "st14",
    width: 0.7,
    height: 0.7
  })))))), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.18_3_",
    className: "st15",
    points: "42.2,-70.5 41.8,-70.2 41.8,-69.4 42.2,-69.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.19_3_",
    className: "st16",
    points: "41.1,-69.4 41.8,-69.4 42.2,-69.1 40.7,-69.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.20_3_",
    className: "st17",
    points: "41.1,-70.2 41.1,-69.4 40.7,-69.1 40.7,-70.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.21_3_",
    className: "st3",
    points: "42.2,-70.5 41.8,-70.2 41.1,-70.2 40.7,-70.5  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2811_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, -0.6572, 21.1461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2812_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2813_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2814_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.2.0.0.0.0.22_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.2.0.0.0.0.22.0_3_",
    x: 86.1,
    y: 37.2,
    className: "st14",
    width: 0.7,
    height: 0.7
  })))))), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.23_3_",
    className: "st15",
    points: "37.7,-66 37.3,-65.7 37.3,-64.9 37.7,-64.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.24_3_",
    className: "st16",
    points: "36.6,-64.9 37.3,-64.9 37.7,-64.6 36.2,-64.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.25_3_",
    className: "st17",
    points: "36.6,-65.7 36.6,-64.9 36.2,-64.6 36.2,-66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.26_3_",
    className: "st3",
    points: "37.7,-66 37.3,-65.7 36.6,-65.7 36.2,-66  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2807_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 6.543, 13.9439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2808_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2809_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2810_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.2.0.0.0.0.27_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.2.0.0.0.0.27.0_3_",
    x: 83.4,
    y: 30,
    className: "st14",
    width: 0.7,
    height: 0.7
  })))))), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.28_3_",
    className: "st15",
    points: "37.7,-70.5 37.3,-70.2 37.3,-69.4 37.7,-69.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.29_3_",
    className: "st16",
    points: "36.6,-69.4 37.3,-69.4 37.7,-69.1 36.2,-69.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.30_3_",
    className: "st17",
    points: "36.6,-70.2 36.6,-69.4 36.2,-69.1 36.2,-70.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.31_3_",
    className: "st3",
    points: "37.7,-70.5 37.3,-70.2 36.6,-70.2 36.2,-70.5  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2803_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, -7.8591, 13.9442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2804_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2805_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2806_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.2.0.0.0.0.32_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.2.0.0.0.0.32.0_3_",
    x: 78.9,
    y: 39.9,
    className: "st14",
    width: 0.7,
    height: 0.7
  })))))), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.33_3_",
    className: "st15",
    points: "33.1,-66 32.8,-65.7 32.8,-64.9 33.1,-64.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.34_3_",
    className: "st16",
    points: "32,-64.9 32.8,-64.9 33.1,-64.6 31.7,-64.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.35_3_",
    className: "st17",
    points: "32,-65.7 32,-64.9 31.7,-64.6 31.7,-66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.36_3_",
    className: "st3",
    points: "33.1,-66 32.8,-65.7 32,-65.7 31.7,-66  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2799_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, -0.6574, 6.7435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2800_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2801_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2802_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.2.0.0.0.0.37_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.2.0.0.0.0.37.0_3_",
    x: 76.2,
    y: 32.7,
    className: "st14",
    width: 0.7,
    height: 0.7
  })))))), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.38_3_",
    className: "st15",
    points: "33.1,-70.5 32.8,-70.2 32.8,-69.4 33.1,-69.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.39_3_",
    className: "st16",
    points: "32,-69.4 32.8,-69.4 33.1,-69.1 31.7,-69.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.40_3_",
    className: "st17",
    points: "32,-70.2 32,-69.4 31.7,-69.1 31.7,-70.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.2.0.0.0.0.41_3_",
    className: "st3",
    points: "33.1,-70.5 32.8,-70.2 32,-70.2 31.7,-70.5  "
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2657_",
    transform: "matrix(1, 0, 0, 1, 59.7671, 12.9035)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2659_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2662_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2665_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.3_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32_x03_7_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2668_",
    transform: "matrix(-1, 0, 0, -1, 21.313, 14.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2671_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2674_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2677_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.3.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.3.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.3.0.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.0_3_",
    className: "st7",
    points: "43.7,18 43.7,15.6 43.7,13.5 43.7,11 42.7,10 40.3,10  39.3,11 39.3,13.5 39.3,15.6 39.3,18 40.3,19 42.7,19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.1_3_",
    className: "st7",
    points: "39.2,18 39.2,15.6 39.2,13.5 39.2,11 38.2,10 35.8,10  34.8,11 34.8,13.5 34.8,15.6 34.8,18 35.8,19 38.2,19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.2_3_",
    className: "st7",
    points: "34.7,18 34.7,15.6 34.7,13.5 34.7,11 33.7,10 31.2,10  30.3,11 30.3,13.5 30.3,15.6 30.3,18 31.2,19 33.7,19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.3_3_",
    className: "st7",
    points: "43.7,18 43.7,15.6 43.7,13.5 43.7,11 42.7,10 40.3,10  39.3,11 39.3,13.5 39.3,15.6 39.3,18 40.3,19 42.7,19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.4_3_",
    className: "st7",
    points: "39.2,18 39.2,15.6 39.2,13.5 39.2,11 38.2,10 35.8,10  34.8,11 34.8,13.5 34.8,15.6 34.8,18 35.8,19 38.2,19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.5_3_",
    className: "st7",
    points: "34.7,18 34.7,15.6 34.7,13.5 34.7,11 33.7,10 31.2,10  30.3,11 30.3,13.5 30.3,15.6 30.3,18 31.2,19 33.7,19  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.3.0.0.0.0.6_3_",
    x: 31.8,
    y: 11.6,
    className: "st12",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.3.0.0.0.0.7_3_",
    x: 31.8,
    y: 16.1,
    className: "st12",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.3.0.0.0.0.8_3_",
    x: 36.4,
    y: 11.6,
    className: "st12",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.3.0.0.0.0.9_3_",
    x: 36.4,
    y: 16.1,
    className: "st12",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.3.0.0.0.0.10_3_",
    x: 40.9,
    y: 11.6,
    className: "st12",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.3.0.0.0.0.11_3_",
    x: 40.9,
    y: 16.1,
    className: "st13",
    width: 1.4,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.3.0.0.0.0.12_3_",
    x: 41.2,
    y: 16.4,
    className: "st14",
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.13_3_",
    className: "st15",
    points: "42.3,16.1 42,16.4 42,17.2 42.3,17.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.14_3_",
    className: "st16",
    points: "41.2,17.2 42,17.2 42.3,17.5 40.9,17.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.15_3_",
    className: "st17",
    points: "41.2,16.4 41.2,17.2 40.9,17.5 40.9,16.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.16_3_",
    className: "st3",
    points: "42.3,16.1 42,16.4 41.2,16.4 40.9,16.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.3.0.0.0.0.17_3_",
    x: 41.2,
    y: 11.9,
    className: "st14",
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.18_3_",
    className: "st15",
    points: "42.3,11.6 42,11.9 42,12.6 42.3,13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.19_3_",
    className: "st16",
    points: "41.2,12.6 42,12.6 42.3,13 40.9,13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.20_3_",
    className: "st17",
    points: "41.2,11.9 41.2,12.6 40.9,13 40.9,11.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.21_3_",
    className: "st3",
    points: "42.3,11.6 42,11.9 41.2,11.9 40.9,11.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.3.0.0.0.0.22_3_",
    x: 36.7,
    y: 16.4,
    className: "st14",
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.23_3_",
    className: "st15",
    points: "37.8,16.1 37.5,16.4 37.5,17.2 37.8,17.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.24_3_",
    className: "st16",
    points: "36.7,17.2 37.5,17.2 37.8,17.5 36.4,17.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.25_3_",
    className: "st17",
    points: "36.7,16.4 36.7,17.2 36.4,17.5 36.4,16.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.26_3_",
    className: "st3",
    points: "37.8,16.1 37.5,16.4 36.7,16.4 36.4,16.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.3.0.0.0.0.27_3_",
    x: 36.7,
    y: 11.9,
    className: "st14",
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.28_3_",
    className: "st15",
    points: "37.8,11.6 37.5,11.9 37.5,12.6 37.8,13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.29_3_",
    className: "st16",
    points: "36.7,12.6 37.5,12.6 37.8,13 36.4,13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.30_3_",
    className: "st17",
    points: "36.7,11.9 36.7,12.6 36.4,13 36.4,11.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.31_3_",
    className: "st3",
    points: "37.8,11.6 37.5,11.9 36.7,11.9 36.4,11.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.3.0.0.0.0.32_3_",
    x: 32.2,
    y: 16.4,
    className: "st14",
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.33_3_",
    className: "st15",
    points: "33.3,16.1 32.9,16.4 32.9,17.2 33.3,17.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.34_3_",
    className: "st16",
    points: "32.2,17.2 32.9,17.2 33.3,17.5 31.8,17.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.35_3_",
    className: "st17",
    points: "32.2,16.4 32.2,17.2 31.8,17.5 31.8,16.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.36_3_",
    className: "st3",
    points: "33.3,16.1 32.9,16.4 32.2,16.4 31.8,16.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.3.0.0.0.0.37_3_",
    x: 32.2,
    y: 11.9,
    className: "st14",
    width: 0.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.38_3_",
    className: "st15",
    points: "33.3,11.6 32.9,11.9 32.9,12.6 33.3,13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.39_3_",
    className: "st16",
    points: "32.2,12.6 32.9,12.6 33.3,13 31.8,13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.40_3_",
    className: "st17",
    points: "32.2,11.9 32.2,12.6 31.8,13 31.8,11.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.3.0.0.0.0.41_3_",
    className: "st3",
    points: "33.3,11.6 32.9,11.9 32.2,11.9 31.8,11.6  "
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2649_",
    transform: "matrix(1, 0, 0, 1, 144.692, 3.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2650_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2651_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2652_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.4_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_x08_6_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2653_",
    transform: "matrix(-1, 0, 0, -1, 57.6, 7.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2654_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2655_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2656_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.4.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.4.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.4.0.0.0.0_3_",
    x: 75.4,
    y: 3.8,
    className: "st7",
    width: 36.2,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.4.0.0.0.1_3_",
    x: 108.5,
    y: 5.2,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.2_3_",
    className: "st8",
    points: "110.9,7.6 110.2,6.9 108.5,6.9 107.8,7.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.3_3_",
    className: "st9",
    points: "107.8,7.6 108.5,6.9 108.5,5.2 107.8,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.4_3_",
    className: "st10",
    points: "107.8,4.5 108.5,5.2 110.2,5.2 110.9,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.5_3_",
    className: "st11",
    points: "110.9,4.5 110.2,5.2 110.2,6.9 110.9,7.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.4.0.0.0.6_3_",
    x: 104,
    y: 5.2,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.7_3_",
    className: "st8",
    points: "106.3,7.6 105.7,6.9 104,6.9 103.3,7.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.8_3_",
    className: "st9",
    points: "103.3,7.6 104,6.9 104,5.2 103.3,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.9_3_",
    className: "st10",
    points: "103.3,4.5 104,5.2 105.7,5.2 106.3,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.10_3_",
    className: "st11",
    points: "106.3,4.5 105.7,5.2 105.7,6.9 106.3,7.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.4.0.0.0.11_3_",
    x: 99.4,
    y: 5.2,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.12_3_",
    className: "st8",
    points: "101.8,7.6 101.2,6.9 99.4,6.9 98.8,7.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.13_3_",
    className: "st9",
    points: "98.8,7.6 99.4,6.9 99.4,5.2 98.8,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.14_3_",
    className: "st10",
    points: "98.8,4.5 99.4,5.2 101.2,5.2 101.8,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.15_3_",
    className: "st11",
    points: "101.8,4.5 101.2,5.2 101.2,6.9 101.8,7.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.4.0.0.0.16_3_",
    x: 94.9,
    y: 5.2,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.17_3_",
    className: "st8",
    points: "97.3,7.6 96.7,6.9 94.9,6.9 94.3,7.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.18_3_",
    className: "st9",
    points: "94.3,7.6 94.9,6.9 94.9,5.2 94.3,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.19_3_",
    className: "st10",
    points: "94.3,4.5 94.9,5.2 96.7,5.2 97.3,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.20_3_",
    className: "st11",
    points: "97.3,4.5 96.7,5.2 96.7,6.9 97.3,7.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.4.0.0.0.21_3_",
    x: 90.4,
    y: 5.2,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.22_3_",
    className: "st8",
    points: "92.8,7.6 92.1,6.9 90.4,6.9 89.7,7.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.23_3_",
    className: "st9",
    points: "89.7,7.6 90.4,6.9 90.4,5.2 89.7,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.24_3_",
    className: "st10",
    points: "89.7,4.5 90.4,5.2 92.1,5.2 92.8,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.25_3_",
    className: "st11",
    points: "92.8,4.5 92.1,5.2 92.1,6.9 92.8,7.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.4.0.0.0.26_3_",
    x: 85.9,
    y: 5.2,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.27_3_",
    className: "st8",
    points: "88.2,7.6 87.6,6.9 85.9,6.9 85.2,7.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.28_3_",
    className: "st9",
    points: "85.2,7.6 85.9,6.9 85.9,5.2 85.2,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.29_3_",
    className: "st10",
    points: "85.2,4.5 85.9,5.2 87.6,5.2 88.2,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.30_3_",
    className: "st11",
    points: "88.2,4.5 87.6,5.2 87.6,6.9 88.2,7.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.4.0.0.0.31_3_",
    x: 81.3,
    y: 5.2,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.32_3_",
    className: "st8",
    points: "83.7,7.6 83.1,6.9 81.3,6.9 80.7,7.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.33_3_",
    className: "st9",
    points: "80.7,7.6 81.3,6.9 81.3,5.2 80.7,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.34_3_",
    className: "st10",
    points: "80.7,4.5 81.3,5.2 83.1,5.2 83.7,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.35_3_",
    className: "st11",
    points: "83.7,4.5 83.1,5.2 83.1,6.9 83.7,7.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.4.0.0.0.36_3_",
    x: 76.8,
    y: 5.2,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.37_3_",
    className: "st8",
    points: "79.2,7.6 78.6,6.9 76.8,6.9 76.2,7.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.38_3_",
    className: "st9",
    points: "76.2,7.6 76.8,6.9 76.8,5.2 76.2,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.39_3_",
    className: "st10",
    points: "76.2,4.5 76.8,5.2 78.6,5.2 79.2,4.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.4.0.0.0.40_3_",
    className: "st11",
    points: "79.2,4.5 78.6,5.2 78.6,6.9 79.2,7.6  "
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2330_",
    transform: "matrix(1, 0, 0, 1, 80.1173, 116.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2331_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2332_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2363_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.7_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "panasonic_d_8_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2378_",
    transform: "matrix(0, 1, -1, 0, 19.39, -1.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2379_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2381_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2384_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.7.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.7.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.7.0.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2645_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 9.7242, 8.6814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2646_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2647_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2648_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.7.0.0.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.7.0.0.0.0.0.0_3_",
    x: 33.4,
    y: 39.7,
    className: "st18",
    width: 0.8,
    height: 0.7
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2641_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 29.1148, -10.7073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2642_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2643_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2644_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.7.0.0.0.0.1_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.7.0.0.0.0.1.0_3_",
    x: 52.8,
    y: 71.2,
    className: "st18",
    width: 0.8,
    height: 0.7
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2637_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 10.2611, 9.2182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2638_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2639_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2640_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.7.0.0.0.0.2_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.7.0.0.0.0.2.0_3_",
    x: 32.9,
    y: 40.2,
    className: "st19",
    width: 0.1,
    height: 0.7
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2405_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 29.6512, -10.1709)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2551_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2635_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2636_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.7.0.0.0.0.3_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.7.0.0.0.0.3.0_3_",
    x: 52.3,
    y: 71.8,
    className: "st19",
    width: 0.1,
    height: 0.7
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2393_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 9.1903, 8.1474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2396_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2401_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2404_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.7.0.0.0.0.4_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.7.0.0.0.0.4.0_3_",
    x: 34.6,
    y: 39.1,
    className: "st20",
    width: 0.1,
    height: 0.7
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2386_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 28.5809, -11.2412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2389_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2390_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2391_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.7.0.0.0.0.5_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.7.0.0.0.0.5.0_3_",
    x: 54,
    y: 70.7,
    className: "st20",
    width: 0.1,
    height: 0.7
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.7.0.0.0.0.6_3_",
    className: "st21",
    d: "M-39.7,48.3l8.3,0c0.5,0,0.9-0.4,0.9-0.9l0-9.8 c0-0.5-0.4-0.9-0.9-0.9l-8.3,0l-2.4,2.4l0,2.3l0,2.3l0,2.2L-39.7,48.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_x30_.1.7.0.0.0.0.7_3_",
    className: "st22",
    cx: -36.4,
    cy: 42.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.7.0.0.0.0.8_3_",
    className: "st1",
    d: "M-39.7,48.3l8.3,0c0.5,0,0.9-0.4,0.9-0.9l0-9.8 c0-0.5-0.4-0.9-0.9-0.9l-1.7,0l-6.5,0l-2.4,2.4l0,2.3l0,2.3l0,2.2L-39.7,48.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.7.0.0.0.0.9_3_",
    d: "M-42.1,39.3l2.4-2.4l6.5,0l1.7,0c0.5,0,0.9,0.4,0.9,0.9v-0.1 c0-0.5-0.4-0.9-0.9-0.9l-1.7,0l-6.5,0l-2.4,2.4L-42.1,39.3L-42.1,39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.7.0.0.0.0.10_3_",
    className: "st23",
    d: "M-30.6,47.3c0,0.5-0.4,0.9-0.9,0.9l-8.3,0l-2.4-2.4v0.1l2.4,2.4 l8.3,0c0.5,0,0.9-0.4,0.9-0.9V47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.7.0.0.0.0.11_3_",
    className: "st22",
    d: "M-36.4,37c1.2,0,2.3,0.4,3.2,1c1.4,1,2.3,2.6,2.3,4.5 c0,1.8-0.9,3.5-2.3,4.5c-0.9,0.6-2,1-3.2,1c-3,0-5.5-2.4-5.5-5.5C-41.8,39.4-39.4,37-36.4,37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.7.0.0.0.0.12_3_",
    d: "M-30.9,42.5c0-1.8-0.9-3.5-2.3-4.5l0,8.9C-31.8,46-30.9,44.4-30.9,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.7.0.0.0.0.13_3_",
    className: "st24",
    d: "M-41.8,42.4c0,3,2.4,5.5,5.5,5.5c1.2,0,2.3-0.4,3.2-1 c1.4-1,2.3-2.6,2.3-4.5v0.2c0,1.8-0.9,3.5-2.3,4.5c-0.9,0.6-2,1-3.2,1c-3,0-5.5-2.4-5.5-5.5V42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.7.0.0.0.0.14_3_",
    className: "st25",
    d: "M-30.9,42.7c0-1.8-0.9-3.5-2.3-4.5v-0.1c1.4,1,2.3,2.6,2.3,4.5 V42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.7.0.0.0.0.15_3_",
    className: "st26",
    d: "M-33.2,38.2c-0.9-0.6-2-1-3.2-1c-3,0-5.5,2.4-5.5,5.5v-0.1 c0-3,2.4-5.5,5.5-5.5c1.2,0,2.3,0.4,3.2,1V38.2z"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2273_",
    transform: "matrix(1, 0, 0, 1, 59.9571, 116.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2292_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2293_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2294_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.8_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "panasonic_d_7_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2295_",
    transform: "matrix(0, 1, -1, 0, 19.39, -1.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2296_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2297_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2298_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.8.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.8.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.8.0.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2323_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 9.7247, 8.6818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2326_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2328_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2329_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.8.0.0.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.8.0.0.0.0.0.0_3_",
    x: 25.9,
    y: 39.7,
    className: "st18",
    width: 0.8,
    height: 0.7
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2318_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 29.1148, -10.7074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2319_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2320_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2321_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.8.0.0.0.0.1_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.8.0.0.0.0.1.0_3_",
    x: 45.3,
    y: 71.2,
    className: "st18",
    width: 0.8,
    height: 0.7
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2314_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 10.261, 9.2182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2315_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2316_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2317_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.8.0.0.0.0.2_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.8.0.0.0.0.2.0_3_",
    x: 25.4,
    y: 40.2,
    className: "st19",
    width: 0.1,
    height: 0.7
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2307_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 29.6506, -10.1715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2308_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2311_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2313_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.8.0.0.0.0.3_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.8.0.0.0.0.3.0_3_",
    x: 44.8,
    y: 71.8,
    className: "st19",
    width: 0.1,
    height: 0.7
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2303_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 9.1902, 8.1474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2304_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2305_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2306_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.8.0.0.0.0.4_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.8.0.0.0.0.4.0_3_",
    x: 27.1,
    y: 39.1,
    className: "st20",
    width: 0.1,
    height: 0.7
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2299_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 28.5808, -11.2413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2300_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2301_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2302_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.8.0.0.0.0.5_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.8.0.0.0.0.5.0_3_",
    x: 46.5,
    y: 70.7,
    className: "st20",
    width: 0.1,
    height: 0.7
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.8.0.0.0.0.6_3_",
    className: "st21",
    d: "M-39.7,40.8l8.3,0c0.5,0,0.9-0.4,0.9-0.9l0-9.8 c0-0.5-0.4-0.9-0.9-0.9l-8.3,0l-2.4,2.4l0,2.3l0,2.3l0,2.2L-39.7,40.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_x30_.1.8.0.0.0.0.7_3_",
    className: "st22",
    cx: -36.4,
    cy: 35,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.8.0.0.0.0.8_3_",
    className: "st1",
    d: "M-39.7,40.8l8.3,0c0.5,0,0.9-0.4,0.9-0.9l0-9.8 c0-0.5-0.4-0.9-0.9-0.9l-1.7,0l-6.5,0l-2.4,2.4l0,2.3l0,2.3l0,2.2L-39.7,40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.8.0.0.0.0.9_3_",
    d: "M-42.1,31.8l2.4-2.4l6.5,0l1.7,0c0.5,0,0.9,0.4,0.9,0.9v-0.1 c0-0.5-0.4-0.9-0.9-0.9l-1.7,0l-6.5,0l-2.4,2.4V31.8L-42.1,31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.8.0.0.0.0.10_3_",
    className: "st23",
    d: "M-30.6,39.8c0,0.5-0.4,0.9-0.9,0.9l-8.3,0l-2.4-2.4v0.1l2.4,2.4 l8.3,0c0.5,0,0.9-0.4,0.9-0.9V39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.8.0.0.0.0.11_3_",
    className: "st22",
    d: "M-36.4,29.5c1.2,0,2.3,0.4,3.2,1c1.4,1,2.3,2.6,2.3,4.5 c0,1.8-0.9,3.5-2.3,4.5c-0.9,0.6-2,1-3.2,1c-3,0-5.5-2.4-5.5-5.5C-41.8,31.9-39.4,29.5-36.4,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.8.0.0.0.0.12_3_",
    d: "M-30.9,35c0-1.8-0.9-3.5-2.3-4.5l0,8.9C-31.8,38.5-30.9,36.9-30.9,35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.8.0.0.0.0.13_3_",
    className: "st24",
    d: "M-41.8,34.9c0,3,2.4,5.5,5.5,5.5c1.2,0,2.3-0.4,3.2-1 c1.4-1,2.3-2.6,2.3-4.5V35c0,1.8-0.9,3.5-2.3,4.5c-0.9,0.6-2,1-3.2,1c-3,0-5.5-2.4-5.5-5.5V34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.8.0.0.0.0.14_3_",
    className: "st25",
    d: "M-30.9,35.2c0-1.8-0.9-3.5-2.3-4.5v-0.1c1.4,1,2.3,2.6,2.3,4.5 V35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.8.0.0.0.0.15_3_",
    className: "st26",
    d: "M-33.2,30.7c-0.9-0.6-2-1-3.2-1c-3,0-5.5,2.4-5.5,5.5l0-0.1 c0-3,2.4-5.5,5.5-5.5c1.2,0,2.3,0.4,3.2,1V30.7z"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2269_",
    transform: "matrix(1, 0, 0, 1, 92.8519, 140.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2270_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2271_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2272_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.9_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_x08_5_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.9.0.0_3_",
    x: -33.8,
    y: -52.4,
    className: "st7",
    width: 36.2,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.9.0.1_3_",
    x: -32.5,
    y: -51,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.2_3_",
    className: "st8",
    points: "-33.1,-51.7 -32.5,-51 -30.7,-51 -30.1,-51.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.3_3_",
    className: "st9",
    points: "-30.1,-51.7 -30.7,-51 -30.7,-49.3 -30.1,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.4_3_",
    className: "st10",
    points: "-30.1,-48.6 -30.7,-49.3 -32.5,-49.3 -33.1,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.5_3_",
    className: "st11",
    points: "-33.1,-48.6 -32.5,-49.3 -32.5,-51 -33.1,-51.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.9.0.6_3_",
    x: -27.9,
    y: -51,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.7_3_",
    className: "st8",
    points: "-28.6,-51.7 -27.9,-51 -26.2,-51 -25.5,-51.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.8_3_",
    className: "st9",
    points: "-25.5,-51.7 -26.2,-51 -26.2,-49.3 -25.5,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.9_3_",
    className: "st10",
    points: "-25.5,-48.6 -26.2,-49.3 -27.9,-49.3 -28.6,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.10_3_",
    className: "st11",
    points: "-28.6,-48.6 -27.9,-49.3 -27.9,-51 -28.6,-51.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.9.0.11_3_",
    x: -23.4,
    y: -51,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.12_3_",
    className: "st8",
    points: "-24,-51.7 -23.4,-51 -21.7,-51 -21,-51.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.13_3_",
    className: "st9",
    points: "-21,-51.7 -21.7,-51 -21.7,-49.3 -21,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.14_3_",
    className: "st10",
    points: "-21,-48.6 -21.7,-49.3 -23.4,-49.3 -24,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.15_3_",
    className: "st11",
    points: "-24,-48.6 -23.4,-49.3 -23.4,-51 -24,-51.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.9.0.16_3_",
    x: -18.9,
    y: -51,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.17_3_",
    className: "st8",
    points: "-19.5,-51.7 -18.9,-51 -17.1,-51 -16.5,-51.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.18_3_",
    className: "st9",
    points: "-16.5,-51.7 -17.1,-51 -17.1,-49.3 -16.5,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.19_3_",
    className: "st10",
    points: "-16.5,-48.6 -17.1,-49.3 -18.9,-49.3 -19.5,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.20_3_",
    className: "st11",
    points: "-19.5,-48.6 -18.9,-49.3 -18.9,-51 -19.5,-51.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.9.0.21_3_",
    x: -14.4,
    y: -51,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.22_3_",
    className: "st8",
    points: "-15,-51.7 -14.4,-51 -12.6,-51 -12,-51.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.23_3_",
    className: "st9",
    points: "-12,-51.7 -12.6,-51 -12.6,-49.3 -12,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.24_3_",
    className: "st10",
    points: "-12,-48.6 -12.6,-49.3 -14.4,-49.3 -15,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.25_3_",
    className: "st11",
    points: "-15,-48.6 -14.4,-49.3 -14.4,-51 -15,-51.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.9.0.26_3_",
    x: -9.8,
    y: -51,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.27_3_",
    className: "st8",
    points: "-10.5,-51.7 -9.8,-51 -8.1,-51 -7.4,-51.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.28_3_",
    className: "st9",
    points: "-7.4,-51.7 -8.1,-51 -8.1,-49.3 -7.4,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.29_3_",
    className: "st10",
    points: "-7.4,-48.6 -8.1,-49.3 -9.8,-49.3 -10.5,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.30_3_",
    className: "st11",
    points: "-10.5,-48.6 -9.8,-49.3 -9.8,-51 -10.5,-51.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.9.0.31_3_",
    x: -5.3,
    y: -51,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.32_3_",
    className: "st8",
    points: "-6,-51.7 -5.3,-51 -3.6,-51 -2.9,-51.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.33_3_",
    className: "st9",
    points: "-2.9,-51.7 -3.6,-51 -3.6,-49.3 -2.9,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.34_3_",
    className: "st10",
    points: "-2.9,-48.6 -3.6,-49.3 -5.3,-49.3 -6,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.35_3_",
    className: "st11",
    points: "-6,-48.6 -5.3,-49.3 -5.3,-51 -6,-51.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.9.0.36_3_",
    x: -0.8,
    y: -51,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.37_3_",
    className: "st8",
    points: "-1.4,-51.7 -0.8,-51 1,-51 1.6,-51.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.38_3_",
    className: "st9",
    points: "1.6,-51.7 1,-51 1,-49.3 1.6,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.39_3_",
    className: "st10",
    points: "1.6,-48.6 1,-49.3 -0.8,-49.3 -1.4,-48.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.9.0.40_3_",
    className: "st11",
    points: "-1.4,-48.6 -0.8,-49.3 -0.8,-51 -1.4,-51.7  "
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1945_",
    transform: "matrix(1, 0, 0, 1, 31.1856, 77.2272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1946_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1947_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1948_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.12_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sot223_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1949_",
    transform: "matrix(0, 1, -1, 0, 19.6385, 0.486504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1950_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1951_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2163_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.12.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.12.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.12.0.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2265_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 34.358, -27.0816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2266_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2267_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2268_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.12.0.0.0.0.0_4_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.12.0.0.0.0.0.0_4_",
    x: 46.5,
    y: 42.9,
    className: "st27",
    width: 3.1,
    height: 2.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2261_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 27.8034, -20.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2262_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2263_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2264_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.12.0.0.0.0.1_4_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.12.0.0.0.0.1.0_4_",
    x: 39.9,
    y: 40.4,
    className: "st27",
    width: 3.1,
    height: 2.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2257_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 21.2482, -13.9718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2258_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2259_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2260_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.12.0.0.0.0.2_4_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.12.0.0.0.0.2.0_4_",
    x: 33.4,
    y: 38,
    className: "st27",
    width: 3.1,
    height: 2.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2253_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 31.983, -29.4566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2254_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2255_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2256_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.12.0.0.0.0.3_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.12.0.0.0.0.3.0_3_",
    x: 48.9,
    y: 40.5,
    className: "st20",
    width: 0.1,
    height: 2.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2219_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 25.4284, -22.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2220_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2221_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2252_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.12.0.0.0.0.4_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.12.0.0.0.0.4.0_3_",
    x: 42.3,
    y: 38,
    className: "st20",
    width: 0.1,
    height: 2.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2214_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 18.8732, -16.3468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2215_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2216_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2217_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.12.0.0.0.0.5_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.12.0.0.0.0.5.0_3_",
    x: 35.8,
    y: 35.6,
    className: "st20",
    width: 0.1,
    height: 2.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2210_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 42.8349, -5.4926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2211_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2212_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2213_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.12.0.0.0.0.6_4_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.12.0.0.0.0.6.0_4_",
    x: 34.2,
    y: 53.3,
    className: "st27",
    width: 3.3,
    height: 6.4
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2168_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 45.3969, -2.9306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2169_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2170_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2209_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.12.0.0.0.0.7_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.12.0.0.0.0.7.0_3_",
    x: 34.9,
    y: 55.9,
    className: "st20",
    width: 0.1,
    height: 6.4
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2164_",
    transform: "matrix(2.57889e-06, 1, -1, 2.57889e-06, 35.224, -13.1073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2165_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2166_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2167_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.12.0.0.0.0.8_4_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.12.0.0.0.0.8.0_4_",
    x: 35.6,
    y: 42.9,
    className: "st28",
    width: 6.2,
    height: 12
  })))))), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.12.0.0.0.0.9_3_",
    className: "st29",
    points: "-7.7,28.7 -19.7,28.7 -19.3,28.3 -8.1,28.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.12.0.0.0.0.10_3_",
    className: "st29",
    points: "-7.7,22.5 -19.7,22.5 -19.3,22.9 -8.1,22.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.12.0.0.0.0.11_3_",
    points: "-7.7,28.7 -7.7,22.5 -8.1,22.9 -8.1,28.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.12.0.0.0.0.12_3_",
    className: "st30",
    points: "-19.7,28.7 -19.7,22.5 -19.3,22.9 -19.3,28.3  "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_x30_.1.12.0.0.0.0.13_3_",
    className: "st29",
    cx: -9,
    cy: 23.9,
    r: 0.5
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1925_",
    transform: "matrix(1, 0, 0, 1, -3.65847, 104.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1926_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1927_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1928_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.13_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "powersupply_dc-21mm_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1929_",
    transform: "matrix(0, 1, -1, 0, 32.3005, 6.84151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1930_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1931_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1932_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.13.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.13.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1933_",
    transform: "matrix(1, 0, 0, 1, 16.998, 98.8718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1934_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1935_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1936_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.13.0.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dc-21mm_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1937_",
    transform: "matrix(0, 1, -1, 0, 38.6844, 13.1725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1938_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1939_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1940_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.13.0.0.0.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.13.0.0.0.0.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.0.0.0_3_",
    x: -115.4,
    y: 78.5,
    className: "st31",
    width: 20.7,
    height: 14.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.0.0.1_3_",
    x: -115.1,
    y: 92,
    className: "st32",
    width: 20.1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.0.0.2_3_",
    x: -115.1,
    y: 88.7,
    className: "st33",
    width: 20.1,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.0.0.3_3_",
    x: -115.1,
    y: 78.8,
    width: 20.7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.0.0.4_3_",
    x: -115.1,
    y: 79.8,
    className: "st34",
    width: 20.7,
    height: 3.7
  })), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.0.1_3_",
    x: -115.4,
    y: 78.5,
    className: "st26",
    width: 0.4,
    height: 14.9
  })), /*#__PURE__*/React.createElement("line", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.1_3_",
    className: "st35",
    x1: -113.6,
    y1: 78.5,
    x2: -113.6,
    y2: 93.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.2_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.2.0_3_",
    x: -96.9,
    y: 78.5,
    className: "st36",
    width: 0.8,
    height: 14.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.2.1_3_",
    className: "st37",
    d: "M-96.3,90.7v-9.5h-8.4 c-2.6,0-4.7,2.1-4.7,4.7c0,2.6,2.1,4.7,4.7,4.7L-96.3,90.7L-96.3,90.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.3_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.3.0_3_",
    className: "st31",
    d: "M-96.3,90.7v-9.5h-8.4 c-2.6,0-4.7,2.1-4.7,4.7c0,2.6,2.1,4.7,4.7,4.7L-96.3,90.7L-96.3,90.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.3.1_3_",
    x: -96.7,
    y: 78,
    className: "st31",
    width: 4.8,
    height: 16
  })), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.4_3_",
    x: -116.5,
    y: 84.2,
    className: "st38",
    width: 1.1,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.5_3_",
    x: -116,
    y: 82.4,
    className: "st32",
    width: 0.6,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.6_3_",
    x: -96.3,
    y: 93.1,
    className: "st32",
    width: 3.9,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.13.0.0.0.0.0.0.0.7_3_",
    x: -96.3,
    y: 78.2,
    width: 3.9,
    height: 0.7
  }))))))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1898_",
    transform: "matrix(1, 0, 0, 1, 3.4818, 23.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1899_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1901_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1902_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.14_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pn61729_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1903_",
    transform: "matrix(0, -1, 1, 0, 1.809, 42.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1904_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1905_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1907_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.14.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.14.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.14.0.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.14.0.0.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.14.0.0.0.0.0.0_3_",
    className: "st27",
    d: "M48.9,7.2v1.9h-1.3h-1.3l0-1.9V6h2c0.3,0,0.6,0.3,0.6,0.6 C48.9,6.6,48.9,7.2,48.9,7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.14.0.0.0.0.0.1_3_",
    className: "st39",
    d: "M48.9,6.5h-2.6V6c0,0,1.9,0,2.1,0C48.6,6,48.9,6.4,48.9,6.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.14.0.0.0.0.1_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1921_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 1.9763, 43.6033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1922_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1923_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1924_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.14.0.0.0.0.1.0_4_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.14.0.0.0.0.1.0.0_4_",
    x: 20.7,
    y: 23.9,
    className: "st40",
    width: 23,
    height: 20.4
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1917_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 24.0981, 21.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1918_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1919_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1920_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.14.0.0.0.0.1.1_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.14.0.0.0.0.1.1.0_3_",
    x: 21.7,
    y: 1.8,
    className: "st27",
    width: 4.8,
    height: 20.4
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1913_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, -9.4585, 24.6065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1914_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1915_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1916_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.14.0.0.0.0.1.2_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.14.0.0.0.0.1.2.0_3_",
    x: 1.8,
    y: 35.4,
    className: "st41",
    width: 27.8,
    height: 1.3
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1909_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 20.9742, 55.0381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1910_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1911_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1912_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.14.0.0.0.0.1.3_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.14.0.0.0.0.1.3.0_3_",
    x: 32.2,
    y: 24,
    className: "st26",
    width: 27.8,
    height: 1.3
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.14.0.0.0.0.2_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.14.0.0.0.0.2.0_3_",
    className: "st40",
    d: "M23.3,7.2l0,1.9l1.3,0l1.3,0l0-1.9l0-1.2l-2,0 c-0.3,0-0.6,0.3-0.6,0.6L23.3,7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.14.0.0.0.0.2.1_3_",
    className: "st22",
    d: "M23.3,6.5l2.6,0l0-0.5c0,0-1.9,0-2.1,0 C23.6,6,23.3,6.4,23.3,6.5z"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "smd_157sw_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.15.0.0_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.15.0.0.0_3_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.15.0.0.0.0_3_",
    className: "st18",
    points: "20,14.1 20,13.9 25.2,13.9 25.2,14.1 29.2,14.1 29.2,4.1 16.1,4.1  16.1,14.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.15.0.0.0.1_3_",
    className: "st18",
    points: "25.2,2.5 25.2,2.7 20,2.7 20,2.5 16.1,2.5 16.1,12.4 29.2,12.4  29.2,2.5  "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_x30_.1.15.0.0.0.2_3_",
    className: "st42",
    cx: 22.6,
    cy: 8.3,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.15.0.0.0.3_3_",
    className: "st26",
    d: "M25.9,8.1c0-1.8-1.4-3.2-3.2-3.2c-1.8,0-3.2,1.4-3.2,3.2v0.2 c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2V8.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_x30_.1.15.0.0.0.4_3_",
    className: "st43",
    cx: 22.6,
    cy: 8.3,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_x30_.1.15.0.0.0.5_3_",
    className: "st43",
    cx: 22.6,
    cy: 8.4,
    r: 3.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.15.0.0.0.6_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.15.0.0.0.6.0_3_",
    className: "st19",
    d: "M22.7,11.4c1.7,0,3.1-1.4,3.1-3.1c0-1.7-1.4-3.1-3.1-3.1h-0.1 c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1L22.7,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x30_.1.15.0.0.0.6.1_3_",
    className: "st20",
    d: "M22.7,5.2c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1h-0.1 c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1H22.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1894_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, -14.7248, 21.5506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1895_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1896_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1897_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.15.0.0.0.7_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.15.0.0.0.7.0_3_",
    x: 5.6,
    y: 32.7,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -25.2546 40.355)",
    className: "st20",
    width: 3.9,
    height: 0.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1881_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, -29.2355, 36.0623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1891_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1892_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1893_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.15.0.0.0.8_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.15.0.0.0.8.0_3_",
    x: 20.1,
    y: 56.3,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -34.3715 78.4956)",
    className: "st20",
    width: 3.9,
    height: 0.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1875_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, -21.6146, 29.1724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1876_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1877_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1880_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.15.0.0.0.9_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.15.0.0.0.9.0_3_",
    x: 12.8,
    y: 44.1,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 -28.8512 59.656)",
    className: "st20",
    width: 5.2,
    height: 0.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1871_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, 3.4298, 39.7056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1872_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1873_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1874_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.15.0.0.0.10_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.15.0.0.0.10.0_3_",
    x: 35.2,
    y: 14.5,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 22.4628 51.7634)",
    className: "st26",
    width: 3.9,
    height: 0.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1808_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, -11.0816, 54.2142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1809_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1810_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1811_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.15.0.0.0.11_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.15.0.0.0.11.0_3_",
    x: 49.7,
    y: 38.2,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 13.3407 89.8988)",
    className: "st26",
    width: 3.9,
    height: 0.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1777_",
    transform: "matrix(-2.54711e-06, -1, 1, -2.54711e-06, -4.1966, 46.5918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1783_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1784_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1786_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.15.0.0.0.12_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.15.0.0.0.12.0_3_",
    x: 41.2,
    y: 26.7,
    transform: "matrix(4.648184e-007 -1 1 4.648184e-007 16.93 70.6025)",
    className: "st26",
    width: 5.2,
    height: 0.2
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.15.0.1_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.15.0.1.0_3_",
    x: 29.2,
    y: 11.4,
    className: "st22",
    width: 1.7,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.15.0.1.1_3_",
    x: 29.2,
    y: 3.7,
    className: "st22",
    width: 1.7,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.15.0.1.2_3_",
    x: 14.5,
    y: 7.2,
    className: "st22",
    width: 1.7,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.15.0.1.3_3_",
    x: 14.5,
    y: 11.4,
    className: "st22",
    width: 1.7,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.15.0.1.4_3_",
    x: 14.5,
    y: 3.7,
    className: "st22",
    width: 1.7,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.15.0.1.5_3_",
    x: 14.5,
    y: 7.2,
    className: "st20",
    width: 0.2,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.15.0.1.6_3_",
    x: 14.5,
    y: 11.4,
    className: "st20",
    width: 0.2,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.15.0.1.7_3_",
    x: 14.5,
    y: 3.7,
    className: "st20",
    width: 0.2,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.15.0.1.8_3_",
    x: 30.9,
    y: 11.4,
    className: "st26",
    width: 0.1,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.15.0.1.9_3_",
    x: 30.9,
    y: 3.7,
    className: "st26",
    width: 0.1,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.15.0.1.10_3_",
    x: 29.2,
    y: 11.4,
    className: "st19",
    width: 0.2,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.15.0.1.11_3_",
    x: 29.2,
    y: 3.7,
    className: "st19",
    width: 0.2,
    height: 1.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1768_",
    transform: "matrix(1, 0, 0, 1, 67.6403, 3.60123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1769_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1771_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1773_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_.1.17_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_x10_4_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.17.0.0_4_",
    x: -25,
    y: -1.3,
    className: "st7",
    width: 45.2,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.17.0.1_13_",
    x: -23.6,
    y: 0,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.2_3_",
    className: "st8",
    points: "-24.2,-0.6 -23.6,0 -21.8,0 -21.2,-0.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.3_3_",
    className: "st9",
    points: "-21.2,-0.6 -21.8,0.1 -21.8,1.8 -21.2,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.4_3_",
    className: "st10",
    points: "-21.2,2.4 -21.8,1.8 -23.6,1.8 -24.2,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.5_3_",
    className: "st11",
    points: "-24.2,2.4 -23.6,1.8 -23.6,0 -24.2,-0.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.17.0.6_3_",
    x: -19,
    y: 0,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.7_3_",
    className: "st8",
    points: "-19.7,-0.6 -19,0 -17.3,0 -16.6,-0.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.8_3_",
    className: "st9",
    points: "-16.6,-0.6 -17.3,0.1 -17.3,1.8 -16.6,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.9_3_",
    className: "st10",
    points: "-16.6,2.4 -17.3,1.8 -19,1.8 -19.7,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.10_3_",
    className: "st11",
    points: "-19.7,2.4 -19,1.8 -19,0 -19.7,-0.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.17.0.11_3_",
    x: -14.5,
    y: 0,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.12_3_",
    className: "st8",
    points: "-15.2,-0.6 -14.5,0 -12.8,0 -12.1,-0.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.13_3_",
    className: "st9",
    points: "-12.1,-0.6 -12.8,0.1 -12.8,1.8 -12.1,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.14_3_",
    className: "st10",
    points: "-12.1,2.4 -12.8,1.8 -14.5,1.8 -15.2,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.15_3_",
    className: "st11",
    points: "-15.2,2.4 -14.5,1.8 -14.5,0 -15.2,-0.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.17.0.16_3_",
    x: -10,
    y: 0,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.17_3_",
    className: "st8",
    points: "-10.6,-0.6 -10,0 -8.2,0 -7.6,-0.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.18_3_",
    className: "st9",
    points: "-7.6,-0.6 -8.2,0.1 -8.2,1.8 -7.6,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.19_3_",
    className: "st10",
    points: "-7.6,2.4 -8.2,1.8 -10,1.8 -10.6,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.20_3_",
    className: "st11",
    points: "-10.6,2.4 -10,1.8 -10,0 -10.6,-0.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.17.0.21_3_",
    x: -5.5,
    y: 0,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.22_3_",
    className: "st8",
    points: "-6.1,-0.6 -5.5,0 -3.7,0 -3.1,-0.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.23_3_",
    className: "st9",
    points: "-3.1,-0.6 -3.7,0.1 -3.7,1.8 -3.1,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.24_3_",
    className: "st10",
    points: "-3.1,2.4 -3.7,1.8 -5.5,1.8 -6.1,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.25_3_",
    className: "st11",
    points: "-6.1,2.4 -5.5,1.8 -5.5,0 -6.1,-0.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.17.0.26_3_",
    x: -0.9,
    y: 0,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.27_3_",
    className: "st8",
    points: "-1.6,-0.6 -0.9,0 0.8,0 1.4,-0.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.28_3_",
    className: "st9",
    points: "1.4,-0.6 0.8,0.1 0.8,1.8 1.4,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.29_3_",
    className: "st10",
    points: "1.4,2.4 0.8,1.8 -0.9,1.8 -1.6,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.30_3_",
    className: "st11",
    points: "-1.6,2.4 -0.9,1.8 -0.9,0 -1.6,-0.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.17.0.31_3_",
    x: 3.6,
    y: 0,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.32_3_",
    className: "st8",
    points: "2.9,-0.6 3.6,0 5.3,0 6,-0.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.33_3_",
    className: "st9",
    points: "6,-0.6 5.3,0.1 5.3,1.8 6,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.34_3_",
    className: "st10",
    points: "6,2.4 5.3,1.8 3.6,1.8 2.9,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.35_3_",
    className: "st11",
    points: "2.9,2.4 3.6,1.8 3.6,0 2.9,-0.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.17.0.36_3_",
    x: 8.1,
    y: 0,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.37_3_",
    className: "st8",
    points: "7.5,-0.6 8.1,0 9.9,0 10.5,-0.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.38_3_",
    className: "st9",
    points: "10.5,-0.6 9.9,0.1 9.9,1.8 10.5,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.39_3_",
    className: "st10",
    points: "10.5,2.4 9.9,1.8 8.1,1.8 7.5,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.40_3_",
    className: "st11",
    points: "7.5,2.4 8.1,1.8 8.1,0 7.5,-0.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.17.0.41_3_",
    x: 12.6,
    y: 0,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.42_3_",
    className: "st8",
    points: "12,-0.6 12.6,0 14.4,0 15,-0.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.43_3_",
    className: "st9",
    points: "15,-0.6 14.4,0.1 14.4,1.8 15,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.44_3_",
    className: "st10",
    points: "15,2.4 14.4,1.8 12.6,1.8 12,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.45_3_",
    className: "st11",
    points: "12,2.4 12.6,1.8 12.6,0 12,-0.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x30_.1.17.0.46_3_",
    x: 17.2,
    y: 0,
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.47_3_",
    className: "st8",
    points: "16.5,-0.6 17.2,0 18.9,0 19.5,-0.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.48_3_",
    className: "st9",
    points: "19.5,-0.6 18.9,0.1 18.9,1.8 19.5,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.49_3_",
    className: "st10",
    points: "19.5,2.4 18.9,1.8 17.2,1.8 16.5,2.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x30_.1.17.0.50_3_",
    className: "st11",
    points: "16.5,2.4 17.2,1.8 17.2,0 16.5,-0.6  "
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArduinoUnoIllustration);
export default __webpack_public_path__ + "static/media/icon-arduino-uno-illustration.b7aacc76ec039c15bc1a6ea117d06261.svg";
export { ForwardRef as ReactComponent };